import { useEffect, useMemo, useState } from 'react'

import { useCurrentMerchantCountryCode } from './useCurrentMerchantCountryCode'
import {
	getStoredSupportEmailCountry,
	getWindow,
	resolveSupportEmail,
	setStoredSupportEmailCountry,
	SUPPORT_EMAIL_COUNTRY_STORAGE_KEY,
} from '../features/support/supportEmail'

const getNavigatorLanguages = () => {
	const nav = getWindow()?.navigator
	if (!nav) return []
	return Array.isArray(nav.languages) ? [...nav.languages] : nav.language ? [nav.language] : []
}

export const useSupportEmail = countryCode => {
	const { currentMerchantCountryCode } = useCurrentMerchantCountryCode()
	const [storedCountryCode, setStoredCountryCode] = useState(getStoredSupportEmailCountry)
	const [navigatorLanguages, setNavigatorLanguages] = useState(getNavigatorLanguages)

	useEffect(() => {
		const windowObject = getWindow()
		if (!windowObject) return undefined

		const handleStorageChange = event => {
			if (!event.key || event.key === SUPPORT_EMAIL_COUNTRY_STORAGE_KEY) {
				setStoredCountryCode(getStoredSupportEmailCountry())
			}
		}
		const handleSupportEmailCountryChange = () => setStoredCountryCode(getStoredSupportEmailCountry())
		const handleLanguageChange = () => setNavigatorLanguages(getNavigatorLanguages())

		windowObject.addEventListener('storage', handleStorageChange)
		windowObject.addEventListener('support-email-country-change', handleSupportEmailCountryChange)
		windowObject.addEventListener('languagechange', handleLanguageChange)

		return () => {
			windowObject.removeEventListener('storage', handleStorageChange)
			windowObject.removeEventListener('support-email-country-change', handleSupportEmailCountryChange)
			windowObject.removeEventListener('languagechange', handleLanguageChange)
		}
	}, [])

	const resolvedSupportEmail = useMemo(
		() =>
			resolveSupportEmail({
				countryCode,
				currentMerchantCountryCode,
				navigatorLanguages,
				storedCountryCode,
			}),
		[countryCode, currentMerchantCountryCode, navigatorLanguages, storedCountryCode],
	)

	return {
		...resolvedSupportEmail,
		setSupportEmailCountry: setStoredSupportEmailCountry,
	}
}
